// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"b61a730d","151":"1c0f64e4","199":"f5204981","241":"2169448a","272":"c8bd0e69","382":"0e91ae1a","481":"973e1765","609":"7e7dfaec","680":"b57757e0","750":"445ff5e2","836":"a57ac9e3","843":"f5626e4c","902":"bcefc116","937":"032bea06","945":"81d7a216"}[chunkId] + ".js";
};